import getSyncToExagonOutbound from '@hooks/configuration/getSyncToExagonOutbound';

const useGetSyncToExagonOutbound = (id) => getSyncToExagonOutbound(id);

export default useGetSyncToExagonOutbound;
